/* eslint-disable */
export default {
    state: {
        connection: null,
    },
    getters: {},
    mutations: {
        connection(state, val) {
            state.connection = val
        }
    },
    actions: {},
}